import { useEventsService } from '@/contexts/EventsProvider/EventsContext';
import { EventName } from '@/api/services/events';
import { logError } from '@/utils/logHandling';
import { User } from '@/stores/store.types';
import { useStoreState } from '@/stores/store';

export const useTracking = () => {
  const eventsService = useEventsService();
  const { isTherapistDemo, isPatientDemo } = useStoreState((state) => ({
    isTherapistDemo: state.isTherapistDemo,
    isPatientDemo: state.isPatientDemo,
  }));

  const trackEvent = async (
    user: User | null,
    eventName: EventName,
    properties?: Record<string, any>,
    timestamp?: Date,
  ) => {
    try {
      if (!eventsService) {
        logError(
          'Events service not available yet, skipping event:',
          eventName,
        );
        return;
      }
      const isDemoMode = isTherapistDemo || isPatientDemo;
      if (!isDemoMode) {
        await eventsService.capture(user, eventName, properties, timestamp);
      }
    } catch (error) {
      logError('Error tracking event:', error);
    }
  };

  return {
    trackEvent,
  };
};
